import { BuilderContent, Content, fetchOneEntry } from '@builder.io/sdk-react';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Button } from 'src/components/common/Button';
import { icons } from 'src/configs/icons';
import { customComponents } from './BuilderIoComponents';

export const BuilderIoStaticPage: FC<{ handleBack: () => void }> = ({ handleBack }) => {
  const params = useParams();
  const { t } = useTranslation();
  const [content, setContent] = useState<BuilderContent | null>(null);

  useEffect(() => {
    fetchOneEntry({
      apiKey: '7cc02c16cad14907bbdb6b11357bcdd7',
      model: 'page',
      query: {
        name: params.staticPathParam,
      },
    }).then((res) => {
      setContent(res);
    });
  }, []);

  return (
    <div>
      <Button
        onClick={handleBack}
        className="promotions-info-page__back-button-wrapper"
        icon={icons.controlPrev}
        justifyContentValue="flex-start"
      >
        <span>{t('backToPromotion')}</span>
      </Button>

      <div style={{ padding: '10px' }}>
        <Content
          model="page"
          content={content}
          apiKey={'7cc02c16cad14907bbdb6b11357bcdd7'}
          customComponents={customComponents}
        />
      </div>
    </div>
  );
};
